/* eslint-disable import/prefer-default-export */
import { gql } from 'graphql-request';

export const listOrderLineItemsGql = gql`
  query listOrderLineItems(
    $limit: Int = 25
    $offset: Int = 0
    $filter: ListOrderLineItemsFilter
    $sortBy: OrderLineItemsSortBy = { sortKey: shipByDate, sortOrder: DESC }
  ) {
    listOrderLineItems(limit: $limit, offset: $offset, filter: $filter, sortBy: $sortBy) {
      count
      results: result {
        orderId
        orderStatus
        patient {
          mpi: patientId
          patientDemographics {
            firstName
            lastName
          }
        }
        partner {
          partnerName
        }
        lineItem {
          itemName
          needsByDate
          shipByDate
          requestedDate
          itemType
          lineItemId
          fillType
          shippingOption
          inBatchShipmentQueue
          isBusinessAddress
          fulfillingPharmacyId
          isOtc
          strength
          ndc
          packSizeValue
          packSizeUnit
          formAlias
          quantity
          lastUpdated
          duplicateOfRxNumber
          tags {
            tagName
            isSystemTag
          }
        }
        partnerAccountId
        source
        isReshipment
        state
        createdAt
        waitingOnFill
        totalInOrder
      }
    }
  }
`;
